export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 200 },
  // {key: '2', headerName: 'Employee Level ID', field: 'id', hide: false, width: 250},
  // { key: '2', headerName: 'Code', field: 'Code', hide: false, width: 300 },
  { key: '3', headerName: 'Service Category', field: 'name', hide: false, width: 500 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 400 }
];